module.exports = __webpack_public_path__ + "static/tibet-23082c02150614ae07ea1df95e783b89.svg";